export enum ApplicationFormSchemaStepAlertFields {
  MESSAGE = 'message',
  SEVERITY = 'severity',
}
